import React from 'react';
import { observer } from 'mobx-react-lite';
import { Route, RouteProps } from 'react-router-dom';

import { useStore } from '@src/models';
import { DefaultPrivateRoute } from './DefaultPrivateRoute';

export const CandidatePublicRoute = observer(function CandidatePublicRoute({ component, ...rest }: RouteProps) {
  const {
    authStore: { isAuthorized, isFetching },
    userStore: { isCandidate }
  } = useStore();

  if (isFetching) {
    return null;
  }

  return <Route component={!isAuthorized || isCandidate ? component : DefaultPrivateRoute} {...rest} />;
});
